<template>
  <div class="primary">
      <v-row class="mb-0">
          <v-col class="text-center white--text">
              Copyright © Fantasy Boxing designed by Right Click Media
          </v-col>
      </v-row>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>